<mat-form-field
    #fallbackOverlayOrigin="cdkOverlayOrigin"
    subscriptSizing="dynamic"
    cdk-overlay-origin
    (click)="toggle()">
    <mat-label *ngIf="label()">{{ label() }}</mat-label>
    <input
        #trigger
        matInput
        [value]="displayValue()"
        [disabled]="disabled()"
        [placeholder]="placeholder()"
        [required]="required()" />
    <mat-hint *ngIf="hint()"> {{ hint() }} </mat-hint>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>

<ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOpen]="panelOpen()"
    [cdkConnectedOverlayOrigin]="trigger"
    (overlayOutsideClick)="close()">
    <mat-tree
        #control
        class="st-tree-menu"
        [dataSource]="dataSource"
        [treeControl]="treeControl">
        <mat-tree-node
            *matTreeNodeDef="let node"
            class="st-tree-menu-item"
            matTreeNodePadding
            matTreeNodeToggle>
            <div
                class="st-tree-menu-item__label"
                [class.st-tree-menu-item__label--selected]="node.selected"
                (click)="handleSelected(node)">
                {{ node?.value }}
                <mat-icon>done</mat-icon>
            </div>
        </mat-tree-node>
        <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            class="st-tree-menu-item"
            matTreeNodePadding>
            <button
                mat-icon-button
                matTreeNodeToggle>
                <mat-icon class="mat-icon-rtl-mirror"> {{ treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down' }} </mat-icon>
            </button>
            <div
                class="st-tree-menu-item__label"
                [class.st-tree-menu-item__label--selected]="node.selected"
                (click)="handleSelected(node)">
                {{ node?.value }}
                <mat-icon>done</mat-icon>
            </div>
        </mat-tree-node>
    </mat-tree>
</ng-template>
